import React, {useEffect, useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Table} from 'antd';
import {ColumnFilterItem, SorterResult} from 'antd/es/table/interface';
import {Shell} from 'components/Shell';
import {observer} from 'mobx-react-lite';
import {TasksState} from 'store/tasks/TasksState';
import {ServiceActionListDto} from '../../../../../../PRMGApiClient';
import {appState} from '../../../store/AppStore';
import {serviceTasksColumns} from '../utils/ServiceTaskColumns';

export const TaskListView: React.FC = observer((): JSX.Element => {
  const {t} = useTranslation();

  const [state] = useState(() => new TasksState());

  const data = useMemo(() => state.items, [state.items]);

  useEffect(() => state.loadTableItems(), [state]);

  const columns = useMemo(() => {
    for (const col of serviceTasksColumns) {
      if (col.key === 'assignee') {
        col.filters =
          (appState.commonData?.employees?.map((e) => ({
            text: `${e.firstName} ${e.lastName}`,
            value: e.id,
          })) as ColumnFilterItem[]) ?? [];
      }
    }
    return serviceTasksColumns;
  }, []);

  return (
    <Shell title={t('Tasks')}>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={data}
        pagination={{
          current: state.pageNumber,
          total: state.total,
          pageSize: state.pageSize,
          position: ['bottomRight'],
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
        }}
        loading={appState.isLoading}
        onChange={(pagination, filters, sorters) => {
          state.setPagination(pagination);
          state.setFilters(filters);
          state.setSorters(sorters as SorterResult<ServiceActionListDto>);
        }}
      />
    </Shell>
  );
});
